/* product-plan.js — draws this product's plan and names the days.

   The count comes from Liquid, which computed it from the same theme setting
   the cart reads. Only the DATES are computed here, by the shared clock, so
   the page and the checkout can never quote different arithmetic.

   The first payment is made the day the order is placed; the rest come out
   on the same weekday, starting a week later (no payday to pick since
   2026-10-13). The count includes today's payment. */
(function () {
  'use strict';
  function boot() {
    var clock = window.LaybyClock;
    if (!clock) return;
    document.querySelectorAll('[data-product-plan]').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var n = parseInt(root.dataset.payments, 10) || 1;
      var dates = { from: clock.orderDay() };
      var next = clock.paymentDate(1, dates);
      var last = clock.paymentDate(n - 1, dates);
      var day = clock.DAY_NAMES[next.getDay()];
      var rest = n - 1;

      var h = root.querySelector('[data-plan-heading]');
      if (h) h.textContent = rest > 1 ? 'Today, then ' + rest + ' ' + day + 's.' : rest === 1 ? 'Today, then one ' + day + '.' : 'One payment, today.';

      var d = root.querySelector('[data-plan-dates]');
      if (d) {
        if (rest === 0) {
          d.innerHTML = 'Paid in full <b>today</b>. Then it ships free.';
        } else if (rest === 1) {
          d.innerHTML = 'First payment <b>today</b>, last one <b>' + clock.fmtLong(last) + '</b>. Then it ships free.';
        } else {
          d.innerHTML = 'First payment <b>today</b>, then every ' + day + ' from <b>' + clock.fmtLong(next) +
            '</b> to <b>' + clock.fmtLong(last) + '</b>. Then it ships free.';
        }
      }

      var road = root.querySelector('[data-road]');
      if (road && window.LaybyRoad) {
        window.LaybyRoad.register(road, function () { return { payments: n }; });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
